export type DivPropsT = React.HTMLAttributes<HTMLDivElement> & {
  as?: React.ElementType;
};

export const Div: React.FC<DivPropsT> = ({
  as: Component = 'div',
  children,
  ...props
}) => {
  return <Component {...props}>{children}</Component>;
};
